import { render } from "./ViewUserDetails.vue?vue&type=template&id=2fd0fba8&scoped=true"
import script from "./ViewUserDetails.vue?vue&type=script&lang=js"
export * from "./ViewUserDetails.vue?vue&type=script&lang=js"

import "./ViewUserDetails.vue?vue&type=style&index=0&id=2fd0fba8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd0fba8"]])

export default __exports__